import React, { useEffect, useState } from 'react'
import SectionContainer from '../../../Homepage/SectionContainer'
import BreadCrumb from '../../../component/BreadCrumb/BreadCrumb'
import { Col, Container, Row } from 'reactstrap';
// import aboutImg from "../../../assets/kangaroo/aboutUsweb.webp"
import TimerModal from '../../../component/TimerModal/TimerModal';
import "../About.css"
import MessageService from '../../../services/MesssageService';
import { useLocation } from 'react-router-dom';
import { imageBaseApi } from '../../../services/imageBaseApi';
const AboutMessage = () => {
const location = useLocation();
  const path = location.pathname.split("/").filter(Boolean).pop();

  const [data, setData] = useState();
  console.log("🚀 ~ AboutMessage ~ data:", data)
  const fetchData = async () => {
    try {
      const response = await MessageService.getbySlug(path);
      console.log("🚀 ~ fetchData ~ response:", response)
      setData(response);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchData();
  }, [location]);
  return (
    <SectionContainer>
      <Container fluid>
        <Row>
          <Col className='my-4'>
            <BreadCrumb items={[
              { title: "HOME", link: "/" },
              { title: "ABOUT", link: "#" },
              { title: "MESSAGE FROM CEO" },
            ]} instituition={false} className="" />
          </Col>
        </Row>
        <Row>
          <Col md={8}>
            <h1 className='font-level-4 lh-1' style={{ marginBottom: "4.5rem" }}>{data?.heading}</h1>
          </Col>
        </Row>
        <Row className='align-items-center '>
          <Col lg={6} sm={12}><img src={`${imageBaseApi}${data?.ceoImage?.url}`} className="w-100 h-100 mb-4 mb-md-0" alt="" fluid /></Col>
          <Col lg={6} sm={12}>

            <p className='about-intro-font '>
              {data?.subHeading}</p></Col>
        </Row>
        <Row  >
          <Col style={{ marginTop: "3.7rem", marginBottom: "18rem" }}>
            <p className='country-paragraph-text ' dangerouslySetInnerHTML={{ __html: data?.message }}>
                {/* I warmly welcome all international students and graduates who have chosen Australia as part of their academic and professional journey. Kangaroo Education & Visa Services (KEVS) was established with a clear purpose — to support students after they arrive in Australia and help them navigate the practical, regulatory, and educational responsibilities that come with being onshore.
              <br /> <br />
              While reaching Australia is an important milestone, the journey does not end there. Students often face new challenges related to visa conditions, education progression, health cover, and financial compliance. KEVS exists to provide reliable, accurate, and responsible guidance at these critical stages, ensuring students can move forward with confidence and clarity. <br /> <br />

              Our onshore presence in Sydney, Adelaide, and Hobart allows us to work closely with students and respond to their needs in a timely and personalised manner. We focus on understanding each individual’s situation before offering guidance, because onshore decisions often carry direct compliance implications and long-term consequences. <br /> <br />

              Integrity, transparency, and accountability remain at the core of our work. We do not believe in shortcuts or unrealistic assurances. Instead, we are committed to helping students understand their options, obligations, and next steps clearly — so they can make informed decisions that protect their future in Australia. <br /> <br />

              It gives me great pride to see students progress confidently through their onshore journey with the right support in place. I invite you to engage with KEVS as your trusted onshore partner, and allow us to support you with clarity, care, and responsibility at every step.
              <br /> <br />
              <span className='fw-bold'>Mahesh Babu Timalsina </span> Founder & CEO */}
              {/* {data?.message} */}
              </p>
          </Col>
        </Row>

      </Container>
    </SectionContainer>
  )
}

export default AboutMessage
